import React, { Component } from 'react';
import Loader from "../../Loader"
export default class Pdf extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }
  componentDidMount(){
  }
  render() {
    return(
      <div>
      <div id="loader" style={styles.loader} >
      <Loader />
      </div>
        <iframe style={styles.iframe} src={this.props.pdf}  frameBorder="0"></iframe>
      </div>
      )
  }
}
const styles = {
  iframe: {
    width: "100%",
    height: "30cm",
    position: "relative",
    top: "0px",
    overflow: "hidden",
    left: "0px",
    right: "0px",
    bottom: "0px"
  },
  loader: {
    position: "relative",
    left: `50%`,
    top: `40vh`,
    zIndex: "-1",
    width: "40%"
  }
}



